import { Typography } from '@natu/ui/Typography';

interface LighthouseScorePerformanceLegendProps {
  color: string;
  label: string;
}

export const LighthouseScorePerformanceLegend = ({
  color,
  label,
}: LighthouseScorePerformanceLegendProps) => (
  <div className="flex items-center justify-center gap-x-1">
    <div style={{ background: color }} className="h-2 w-2 shrink-0 rounded-full" />
    <Typography variant="text-sm" className="font-medium text-gray-500">
      {label}
    </Typography>
  </div>
);
